import { TokenTypes } from '../services/AccessTokenManager';

export type DashboardJwt = {
  userId: number;
  companyId: number;
  isImpersonating?: boolean;
};

export type PartnerJwt = {
  type: TokenTypes.PartnerAccessToken;
  partnerId: number;
} | {
  type: TokenTypes.PartnerUserAccessToken;
  partnerUserId: string;
  partnerId: number;
}

export function parseJwt<T extends DashboardJwt | PartnerJwt>(token: string): T {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export function generateOtpCode(): string {
  return Math.floor(100000 + Math.random() * 900000).toString();
}